import SectionStoresCarousel from './SectionStoresCarousel';
export default SectionStoresCarousel;
